import { extendTheme } from '@chakra-ui/react';
import { withProse } from '@nikolovlazar/chakra-ui-prose';
import { baseTheme, proseConfig } from '.';

import buttonTheme from './components/buttonTheme';
import PDPContainerTheme from './components/PDPcontainerTheme';
import badgeTheme from './components/badgeTheme';
import formLabelTheme from './components/formLabelTheme';
import inputTheme from './components/inputTheme';

const PDPTheme = extendTheme(
  {
    ...baseTheme,
    styles: {
      global: {
        '#footer-top, #footer-bottom': {
          px: { base: '24px', md: '40px', lg: '80px', '2xl': '120px' },
        },
      },
    },
    components: {
      Button: buttonTheme,
      Container: PDPContainerTheme,
      Badge: badgeTheme,
      FormLabel: formLabelTheme,
      Input: inputTheme,
    },
  },
  withProse(proseConfig)
);

export default PDPTheme;
